export default "__VITE_ASSET__CPXFq0TK__"